import React, { useEffect } from "react";
import "./tourhome.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";
import { Helmet } from "react-helmet";

const Tourhome = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="tourhome">
      <Helmet>
        <title>Egypt Tours & Trips | Myths Egypt Tours</title>
        <meta
          name="description"
          content="Plan your Egypt tours and trips with Myths Egypt Tours. Explore Cairo, Luxor, Aswan, and the Red Sea with professional guides."
        />
        <meta
          name="keywords"
          content="Egypt tours, Cairo day trips, Luxor Aswan tour, Myths Egypt Tours"
        />
        <meta property="og:title" content="Egypt Tours & Trips | Myths Egypt Tours" />
        <meta
          property="og:description"
          content="Experience the best Egypt tours with Myths Egypt Tours – private and group trips across Egypt’s top destinations."
        />
        <meta property="og:url" content="https://mythsegypttours.com/tours" />
        <meta property="og:image" content="https://mythsegypttours.com/og-image.jpg" />
      </Helmet>

      <Banner page="tours" />
    </section>
  );
};

export default Tourhome;
